import { render, staticRenderFns } from "./GiaiTriFormCreate.vue?vue&type=template&id=58b44132"
import script from "./GiaiTriFormCreate.vue?vue&type=script&lang=js"
export * from "./GiaiTriFormCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports